<template>
  <div class="testDetail">
    <van-nav-bar
      fixed
      :title="title"
      left-text
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div class="testDetail_box" v-if="type == 1">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="testDetail_box_list growClub_tab_list_parentList"
          v-for="(item, index) in parentList"
          :key="index"
          @click="goTest(item, 3)"
          :class="{
            isFlex: item.completeRate === null,
            boxHeight: item.isOver !== null,
          }"
        >
          <div class="testDetail_box_list_imgbox" v-if="item.isOver !== null">
            <img
              src="@/assets/images/test-center/pending.png"
              v-if="!item.isOver"
            />
            <img src="@/assets/images/test-center/finish.png" v-else />
          </div>
          <div class="testDetail_box_list_title">
            <p class="title-text">{{ item.questionnaireName }}</p>
            <img
              class="circle-arrow"
              src="../../assets/images/test-center/circle-arrow.png"
              alt="圆箭头"
            />
          </div>
          <div
            class="testDetail_box_list_process"
            v-if="item.completeRate !== null && !item.isOver"
          >
            <div
              class="testDetail_box_list_process_top"
              :style="{
                left:
                  item.completeRate > 70 ? 80 + '%' : item.completeRate + '%',
              }"
            >
              <!-- <img src="@/assets/images/test-center/pic.png" /> -->
              <p>{{ item.completeRate }}%</p>
            </div>
            <div class="testDetail_box_list_process_bot">
              <div
                class="testDetail_box_list_process_bot_left"
                :style="{ width: item.completeRate + '%' }"
              ></div>
              <div
                class="testDetail_box_list_process_bot_right"
                :style="{ width: 100 - item.completeRate + '%' }"
              ></div>
            </div>
          </div>
        </div>
        <div class="noData" v-if="noDataStatus">
          <img
            class="_nodata_"
            src="@/assets/images/test-center/no-data.png"
            alt
          />
          <p class="_nodatap_">现在还没有数据哦！</p>
        </div>
      </van-list>
    </div>
    <div class="testDetail_box" v-else>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="testDetail_box_list growClub_tab_list_childList"
          :class="{
            isFlex: item.completeRate === null,
            boxHeight: item.isOver !== null,
          }"
          v-for="(item, index) in childList"
          :key="index"
          @click="goTest(item, 2)"
        >
          <div class="testDetail_box_list_imgbox" v-if="item.isOver !== null">
            <img
              src="@/assets/images/test-center/pending.png"
              v-if="!item.isOver"
            />
            <img src="@/assets/images/test-center/finish.png" v-else />
          </div>
          <p class="testDetail_box_list_title">{{ item.questionnaireName }}</p>
          <div
            class="testDetail_box_list_process"
            v-if="item.completeRate !== null && !item.isOver"
          >
            <div
              class="testDetail_box_list_process_top"
              :style="{
                left:
                  item.completeRate > 70 ? 80 + '%' : item.completeRate + '%',
              }"
            >
              <!-- <img src="@/assets/images/test-center/pic.png" /> -->
              <p>{{ item.completeRate }}%</p>
            </div>
            <div class="testDetail_box_list_process_bot">
              <div
                class="testDetail_box_list_process_bot_left"
                :style="{ width: item.completeRate + '%' }"
              ></div>
              <div
                class="testDetail_box_list_process_bot_right"
                :style="{ width: 100 - item.completeRate + '%' }"
              ></div>
            </div>
          </div>
        </div>
        <div class="noData" v-if="noDataStatus">
          <img
            class="_nodata_"
            src="@/assets/images/test-center/no-data.png"
            alt
          />
          <p class="_nodatap_">现在还没有数据哦！</p>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { _projectByCategory } from "../../api/test-center";
import Cookies from "js-cookie";
import { decryptBy } from "@/assets/js/encryption";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);
export default {
  name: "test-detail",
  data() {
    return {
      title: "", //
      type: "", //
      parentList: [], // 家长列表
      childList: [], // 儿童列表
      loading: true, //加载
      finished: false, // 结束加载
      current: 1, // 当前请求页码
      noDataStatus: false, //暂无数据状态
    };
  },
  created() {
    this.title = this.$route.query.title;
    this.type = this.$route.query.type;
    this.projectByCategory();
  },
  mounted() {},
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    projectByCategory() {
      let resourceFrom;
      let useObject;
      let parentId = JSON.parse(
        decryptBy(localStorage.getItem("userInfo"))
      ).userId;
      let childId = localStorage.getItem("childId");
      let investType = this.$route.query.investType;
      // if(localStorage.getItem("children")){
      //   let children = JSON.parse(decryptBy(localStorage.getItem("children")));
      //   let child = children.filter((item) => {
      //     return item.id == childId;
      //   });
      // }
      // if (this.type == "1") {
      //   resourceFrom = 3;
      //   useObject = 3;
      // } else {
      //   resourceFrom = 3;
      //   if (child[0].serviceStatus === 1) {
      //     useObject = 2;
      //   } else {
      //     useObject = 1;
      //   }
      // }
      _projectByCategory({
        currentPage: this.current,
        pageSize: 10,
        queryData: {
          childId: this.type == 2 ? "" : childId,
          parentId: parentId,
          investType: investType,
          psyToken: Cookies.get("token"),
          resourceFrom: JSON.parse(decryptBy(localStorage.getItem("userInfo"))).userType == "PARENT" ? 3 : 4,
          useObject: this.type == 2 ? 4 : 3,
        },
      }).then((res) => {
        if (res && res.code == 200) {
          let rows = res.data.records; //请求返回当页的列表
          this.finished = false;
          this.loading = false;
          // // 判断data是否为空
          // if (!rows) {
          // 	this.finished = true;
          // 	this.noDataStatus = true;
          // 	return
          // }
          if (this.type == 1) {
            // 将新数据与老数据进行合并
            if (this.current == 1) {
              // 判断data是否为空
              if (!rows) {
                this.finished = true;
                this.noDataStatus = true;
                return;
              }
              this.parentList = rows;
            } else {
              this.parentList = [...this.parentList, ...rows];
            }
            if (this.parentList.length > 0) {
              this.noDataStatus = false;
            } else {
              this.noDataStatus = true;
            }
          } else {
            // 将新数据与老数据进行合并
            if (this.current == 1) {
              // 判断data是否为空
              if (!rows) {
                this.finished = true;
                this.noDataStatus = true;
                return;
              }
              this.childList = rows;
            } else {
              this.childList = [...this.childList, ...rows];
            }
            // 展示缺省图
            if (this.childList.length > 0) {
              this.noDataStatus = false;
            } else {
              this.noDataStatus = true;
            }
          }
          if (res.data.total <= 10 || rows.length < 10) {
            // 加载结束
            this.finished = true;
          }
        } else {
          this.$toast(res.message);
          this.finished = true;
          this.noDataStatus = true;
        }
      });
    },
    // 滑动加载
    onLoad() {
      this.current++;
      this.projectByCategory();
    },
    // 跳转测试页
    goTest(item, type) {
      // if (item.isOver && item.updateTime && type == 2) {
      //   let today = dayjs(dayjs().format("YYYY-MM-DD"));
      //   let ansDay = dayjs(item.updateTime).format("YYYY-MM-DD");
      //   let cDay = dayjs(ansDay).add(2, "month");
      //   if (today.isBefore(cDay)) {
      //     this.$toast("此问卷已完成，2个月后可再次重新测评");
      //     return;
      //   }
      // }
      this.$router.push({
        path: "/test",
        query: {
          type: type, //数据来源：2、儿童测试 3、家长测试
          title: item.questionnaireName, // 量表名称
          key: item.key, //量表的key
          projectUrl: item.publishUrl, // 量表地址
          resultId: item.resultId, // 量表关联结果Id
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.testDetail {
  background-color: #f5f7fa;
  padding: 46px 20px;
  font-size: 16px;
  color: #2e4344;
  min-height: 100%;
  .main-nav {
    position: fixed;
    width: 100%;
    top: 0;
  }
  .testDetail_box {
    .testDetail_box_list {
      width: 100%;
      margin-top: 8px;
      border-radius: 8px;
      min-height: 120px;
      .testDetail_box_list_imgbox {
        display: flex;
        justify-content: flex-end;
        img {
          width: 56px;
          height: 27px;
          margin-top: 15px;
        }
      }
      .testDetail_box_list_title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 30px 0 33px;
        .title-text {
          width: 214px;
        }
        .circle-arrow {
          width: 22px;
          height: 22px;
        }
      }
      .testDetail_box_list_process {
        position: relative;
        width: 309px;
        margin-left: 18px;
        padding-top: 28px;
        .testDetail_box_list_process_top {
          position: absolute;
          display: flex;
          top: 0;
          margin-left: -17px;
          img {
            width: 32px;
            height: 31px;
            margin-right: 5px;
          }
          p {
            margin-left: 30px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff8340;
            line-height: 32px;
          }
        }
        .testDetail_box_list_process_bot {
          width: 309px;
          height: 8px;
          border-radius: 5px;
          display: flex;
          .testDetail_box_list_process_bot_left {
            background: #ff8340;
            border-radius: 5px;
            height: 8px;
          }
          .testDetail_box_list_process_bot_right {
            height: 8px;
            background: #ffdecc;
          }
        }
      }
    }
    .growClub_tab_list_parentList {
      // background: url(./../../assets/images/test-center/parent-bg.png);
      background-color: #fff;
      background-size: cover;
    }
    .growClub_tab_list_childList {
      // background: url(./../../assets/images/test-center/child-bg.png);
      background-color: #fff;
      background-size: cover;
    }
    .noData {
      padding: 30px;
      text-align: center;
    }
  }
}
.isFlex {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .van-icon {
  color: #000;
}
.boxHeight {
  height: 140px;
}
</style>
